<app-disconnect-overlay></app-disconnect-overlay>
<app-mic-permission-overlay></app-mic-permission-overlay>
@if (this.botConfig) {
<div
  id="chatbot-wrapper"
  class="h-100"
>
  <div id="chat-container">
    <nav
      id="bot-header"
      class="navbar navbar-expand-lg navbar-light"
      [ngStyle]="{
                'background-color': this.getColorFromConfig(true),
                'color': this.getContrastColor(this.getColorFromConfig(true))
              }"
    >
      <div class="container">
        <div class="row align-items-center mx-1">
          <div class="col-auto">
            <div
              class="border-1 border-white border rounded-circle position-absolute"
              style="height: 10px; width: 10px; background-color: #30b37e; margin-left: 32px"
            ></div>
            @if (this.botConfig.hasImage) {
            <img
              [src]="'/api/toolbox/membot/public/botimg/' + this.botConfig._id + '/128'"
              class="rounded-circle"
              style="width: 40px; height: 40px; object-fit: cover;"
              alt=""
            >
            }
            @if (!this.botConfig.hasImage) {
            <i
              [ngStyle]="{
                        'background-color': this.getColorFromConfig(),
                        'color': this.getContrastColor(this.getColorFromConfig())
                      }"
              class="ri-2x p-2 rounded-circle"
              [class]="this.botConfig.icon"
            >
            </i>
            }
          </div>
          <div class="col align-middle text-black">
            <a class="navbar-brand fs-6 fw-bold">{{this.botConfig.name}}</a>
            <small class="d-block text-muted">
              <div
                class="d-inline-block border-1 border-white border rounded-circle"
                style="height: 10px; width: 10px; background-color: #30b37e;"
              ></div>
              <span i18n="@@always-online">immer online</span>
            </small>
          </div>
        </div>
        <div>
        </div>
      </div>
    </nav>
    <div
      id="bot-content"
      style="height: 100%;overflow-y: scroll;"
    >
      <div
        id="messages"
        style="height: 1px;"
        class="mt-4 container"
      >
        @if (this.botConfig) {
        <app-bot-chat-dialog
          id="myDialog"
          [isThinking]="this.thinkingAnimaitionShouldBeShown()"
          [isSending]="this.isSending"
          [botConfig]="this.botConfig"
          [botState]="this.prevBotState"
          [enableDeletionOverride]="true"
          [enableFeedbackOverride]="true"
          [showHistory]="true"
        ></app-bot-chat-dialog>
        }
      </div>
    </div>
    <div id="bot-footer">
      <div class="container">
        <div class="d-flex align-items-end gap-2">
          @if (this.botConfig.userDocumentsEnabled) {
          <app-user-documents
            [botConfig]="this.botConfig"
            [botId]="this.botConfig._id"
          ></app-user-documents>
          }
          <div class="flex-grow-1">
            @if (this.botConfig.promptbarChatActive) {
            <app-bot-prompt
              [botConfig]="this.botConfig"
              [cancelThinking]="this.botConfig.cancelBotThinkingChatActive"
              [voiceInput]="this.botConfig.voiceInputChatActive"
              [switchToAvatar]="this.botConfig.switchToAvatarFromChat"
              [switchToVoice]="this.botConfig.switchToVoiceFromChat"
              [isThinking]="this.isThinking"
              [isSending]="this.isSending"
              [(promptInput)]="promptInput"
              (sendPrompt)="add()"
              (stfu)="this.cancelThinking()"
            ></app-bot-prompt>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<link
  [href]="this.customCssUrl"
  rel="stylesheet"
>
} @else {
<div class="d-flex h-100 w-100 align-items-center justify-content-center flex-column">
  <h1 i18n="@@bot-not-found">
    Dieser Bot ist nicht verfügbar. Er ist entweder nicht öffentlich oder existiert nicht mehr.
  </h1>
  <span i18n="@@bot-not-found-hint">
    Falls das ein Fehler ist, wende dich an den Bot-Besitzer.
  </span>
</div>
}